module.exports = __webpack_public_path__ + "img/swiperImg_record.07481d62.png";